













































import { TargetTrackerAppointment } from '@/shared/target-tracker-appointment';
import { TargetTrackerAppointmentClient } from '@/shared/target-tracker-appointment-client';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TargetTrackerDetail } from './target-tracker-detail';

const typesModule = namespace('types');
const usersModule = namespace('users');

@Component
export default class TargetTrackerDetailTable extends Vue {
    @typesModule.Getter('appointmentProductTypeDescription') private appointmentProductTypeDescription!: (id: string | null) => string;
    @usersModule.Getter('fullName') private legalAdvisorName!: (userId: string) => string;

    @Prop({ required: true }) private appointments!: Array<TargetTrackerAppointment>;
    @Prop({ required: false, default: false }) private showLegalAdvisor!: boolean;
    @Prop({ required: false, default: false }) private showSigning!: boolean;
    @Prop({ required: false, default: false }) private showBanked!: boolean;
    @Prop({ required: false, default: false }) private showCleared!: boolean;

    private get items(): Array<TargetTrackerDetail> {
        const items: Array<TargetTrackerDetail> = [];

        const sortedAppointments = [...this.appointments].sort((a, b) => {
            if (a.date > b.date) { return 1; }
            if (a.date < b.date) { return -1; }
            return 0;
        });

        for (const appointment of sortedAppointments) {
            const numberOfPayments = appointment.payments.length;
            let rowNumber: number = 0;

            const sortedPayments = appointment.payments.sort((a, b) => {
                if (numberOfPayments < 2) { return 0; }
                if (a.index! > b.index!) { return 1; }
                if (a.index! < b.index!) { return -1; }
                return 0;
            });

            for (const payment of sortedPayments) {
                items.push({
                    ...payment,
                    numberOfPayments,
                    rowNumber,
                    appointmentId: appointment.id,
                    clients: appointment.clients,
                });

                rowNumber++;
            }
        }

        return items;
    }

    private accountNo(clients: Array<TargetTrackerAppointmentClient>): string {
        const sortedClients = [...clients].sort((a, b) => {
            if (a.accountNo > b.accountNo) { return 1; }
            if (a.accountNo < b.accountNo) { return -1; }
            return 0;
        });

        return sortedClients.map((client) => client.accountNo).join(' & ');
    }

    private clientName(clients: Array<TargetTrackerAppointmentClient>): string {
        const sortedClients = [...clients].sort((a, b) => {
            if (a.accountNo > b.accountNo) { return 1; }
            if (a.accountNo < b.accountNo) { return -1; }
            return 0;
        });

        if (!sortedClients.length) { return ''; }

        const clientFirstName = sortedClients[0].firstName!.trim();
        const clientLastName = sortedClients[0].lastName!.trim();

        if (sortedClients.length === 1) {
            return `${clientFirstName} ${clientLastName}`.trim();
        }

        const partnerFirstName = sortedClients[1].firstName!.trim();
        const partnerLastName = sortedClients[1].lastName!.trim();

        return clientLastName === partnerLastName
            ? `${clientFirstName} & ${partnerFirstName} ${clientLastName}`
            : `${clientFirstName} ${clientLastName} & ${partnerFirstName} ${partnerLastName}`;
    }
}
